import * as React from "react";
import {StartTestFrame} from './StartTestFrame';
import {Question} from './Question';
import {Result} from './Result';
import "./../assets/scss/App.scss";

export interface AppState {
    phase:number,
    answerCorrectness:boolean,
    correctAnswersCount:number,
    videosLoaded:number
}
export interface AppProps {
    answers:{'y':string,'n':string}[],
    videos:{'y':string,'n':string}[],
    results:{'y':string,'n':string}[]
}

export default class App extends React.Component<AppProps, AppState> {
    constructor(props){
        super(props);
        this.state = {
            phase:0,
            videosLoaded:0,
            answerCorrectness:true,
            correctAnswersCount:0
        };
        this.setAnswer = this.setAnswer.bind(this);
        this.setVideoLoaded = this.setVideoLoaded.bind(this);
        this.startTest = this.startTest.bind(this);
    }

    private startTest() {
        this.setState({
            phase:1
        })
    }

    private setVideoLoaded() {
        this.setState(
            (state,props) => ({
                videosLoaded:state.videosLoaded + 1
            })
        )
    }
    private setAnswer(answerCorrectness) {
        this.setState(
            (state,props) => ({
                answerCorrectness:answerCorrectness === 'y',
                phase: state.phase+1,
                correctAnswersCount: state.correctAnswersCount +
                    (answerCorrectness === 'y' ? 1 : 0)
            })
        )
    }

    render() {
        let frame:JSX.Element,
            result:JSX.Element[] = [],
            videoIds:{'y':string,'n':string}[],
            resultIds:{'y':string,'n':string}[],
            vids:JSX.Element[] = [],
            currentCorrectnessStr = (this.state.answerCorrectness ? 'y' : 'n');

        videoIds = this.props.videos;
        resultIds = this.props.results;

        if(this.state.phase == 0) {
            frame = <StartTestFrame startTest={this.startTest} videosLoaded={this.state.videosLoaded}/>;
        }
        /*vids.push(<Question
            setAnswer={this.setAnswer}
            answers={{'y':'','n':''}}
            questionNumber={0}
            answerCorrectness={'n'}
            videoId={''}
            hideVideo={true}
        />);*/
        for(let i = 0; i < videoIds.length; i++){
            ['y','n'].forEach(function (c) {
                if(videoIds[i][c] != '') {
                    vids.push(
                        <Question
                            setAnswer={this.setAnswer}
                            setVideoLoaded={this.setVideoLoaded}
                            answers={this.props.answers[i]}
                            questionNumber={i}
                            answerCorrectness={c}
                            videoId={videoIds[i][c]}
                            hideVideo={this.state.phase-1 != i || currentCorrectnessStr != c}
                        />
                    );
                }
            }.bind(this));
        }
        if(this.state.phase > 3){
            for(let i = 0; i < resultIds.length; i++){
                ['y','n'].forEach(function (c) {
                    result.push (
                        <Result
                            answerCorrectness={c}
                            answersCount={this.props.answers.length}
                            videoId={resultIds[i][c]}
                            hideVideo={
                                Math.floor(this.state.correctAnswersCount/2) != i ||
                                this.state.phase != 6 ||
                                currentCorrectnessStr != c
                            }
                            rightAnswersCount={this.state.correctAnswersCount}
                        />
                    );
                }.bind(this));
            }
        }
        /*
        if (this.state.phase < 6) {

            frame = (
                <div>
                    {frame}
                    <Question
                    setAnswer={this.setAnswer}
                    answers={this.props.answers[this.props.testNumber-1][questionNumber]}
                    testNumber={this.props.testNumber}
                    questionNumber={this.state.phase}
                    answerCorrectness={this.state.answerCorrectness ? 'y' : 'n'}
                    videoId={videoIds[questionNumber]}
                    hideVideo={hideVideo}
                    />
                </div>);
        } else {
            frame = (
                <div>
                    {frame}
                    <Result
                        testNumber={this.props.testNumber}
                        questionNumber={this.state.phase}
                        answerCorrectness={this.state.answerCorrectness ? 'y' : 'n'}
                        answersCount={this.props.answers[this.props.testNumber-1].length}
                        rightAnswersCount={this.state.correctAnswersCount}
                    />
                </div>);
        }*/
        return (
            <div className={'content'}>
                <div className={'screen _'+this.state.phase}>
                    {frame}
                    {vids}
                    {result}
                </div>
            </div>
        );
    }

}
